import styles from './_app-crash.module.scss';

export const AppCrash = () => {
  return (
    <div className={styles.AppCrash}>
      <h1>Oops! Something went wrong</h1>
      <p>We’re sorry for the inconvenience. It looks like something unexpected happened.</p>
      <h3>Please reload the page</h3>
    </div>
  );
};
